
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M2 7.25A2.25 2.25 0 014.25 5h19.5A2.25 2.25 0 0126 7.25v13.5A2.25 2.25 0 0123.75 23H4.25A2.25 2.25 0 012 20.75V7.25zm2.25-.75a.75.75 0 00-.75.75v13.5c0 .414.336.75.75.75h19.5a.75.75 0 00.75-.75V7.25a.75.75 0 00-.75-.75H4.25z"}}),_c('path',{attrs:{"d":"M13.998 8.621a.75.75 0 01.53.22l3.255 3.254a.75.75 0 01-1.061 1.061l-1.974-1.974v7.446a.75.75 0 11-1.5 0v-7.444l-1.97 1.972a.75.75 0 11-1.061-1.06l3.25-3.255a.75.75 0 01.53-.22z"}})])])
          )
        }
      }
    